// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"10f6d027","11":"e5512a61","173":"06a9043f","217":"c9fb91c1","453":"3a9ed7dd","490":"d18d9355","542":"7445608a","783":"0b94d28d","992":"c57c0ac9"}[chunkId] + ".chunk.js";
};